var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.default_video_url.videoUrl)?_c('video',{staticClass:"swiper_img",attrs:{"id":"swiper_img","controls":"controls","autoplay":"autoplay","webkit-playsinline":"true","poster":_vm.default_video_url.imgesUrl,"src":_vm.default_video_url.videoUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }